import { Component } from "react"
import PropTypes from "prop-types"
import { map, isEmpty, isNaN } from "lodash"
import { Card, InputAdornment, FormControl, TextField } from "@mui/material"
import Tooltip from "components/material/tooltip"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import "./styles.scss"

function getAdornment({ unit }) {
  if (!unit) {
    return null
  }
  return <InputAdornment style={{ whiteSpace: "nowrap" }} position="start">{unit}</InputAdornment>
}
export default class BasketRulesPanel extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    rules: PropTypes.array.isRequired,
    isReadOnly: PropTypes.bool.isRequired,
  }

  onChange = event => {
    const { onChange } = this.props
    const { value } = event.target
    const name = event.target.name
    const parsed = (!isEmpty(value) && !isNaN(value)) ? parseFloat(value) : value
    onChange(name, parsed)
  }

  render() {
    const { rules, isReadOnly } = this.props

    return <div className="basket-rules-panel">
      <Card square>
        <div className="panel-row">
          {map(rules, (elem, index) =>
            <div key={index} className="panel-row-wrapper">
              <div className="row-label">
                {elem.label}
                {elem.tooltip && <Tooltip classes={{ tooltip: "basket-rules-tooltip-content", popper: "basket-rules-tooltip-popper" }} title={elem.tooltip}><InfoOutlinedIcon className="basket-rules-infooutlined-icon" /></Tooltip>}
              </div>
              <div className="row-input">
                <FormControl variant="standard" className="smart-trade-rules-input">
                  <TextField
                    variant="standard"
                    disabled={isReadOnly}
                    name={elem.id}
                    value={elem.value || ""}
                    onChange={this.onChange}
                    error={!!elem.error}
                    type="number"
                    helperText={elem.error}
                    slotProps={{
                      input: {
                        classes: { input: "rule-input" },
                        startAdornment: getAdornment(elem),
                      },

                      htmlInput: {
                        step: elem.step || 0.1,
                      },

                      formHelperText: { error: !!elem.error },
                    }}
                  />
                </FormControl>
              </div>
            </div>,
          )}
        </div>
      </Card>
    </div>
  }
}
